import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFArrowRightForAni } from '@/components/UI/svg/ProductStatic';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamax/pc/');

export default function Comp({}: any) {
    const { Link, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_max_static');
    const { locale } = useRouter();

    return (
        <div className={`${css.gsapdGroupA} gsapdGroupA2`}>
            <div className="a-img-box">
                <EFPic name={['img_5a.webp', 'img_5a.png']} className="fullImgs" />
            </div>
            <div className="a-msg-box">
                <div className="msg-line-a1">{t('Smart Generator')}</div>
                <div className="msg-line-a2">{t('SG_title')}</div>
                <div className="msg-line-desc">{t('SG_desc')}</div>
                <div className="msg-line-tips">{t('SG_notice')}</div>
                {!['cis', 'tw', 'kr'].includes(locale) && (
                    <div className="msg-line-link">
                        <span className="ef-blue-link">
                            <Link href={['us', 'ca'].includes(locale) ? '/dual-fuel-smart-generator' : '/smart-generator'}>
                                {t('learn_more')}
                                <span className="ef-blue-link-more">
                                    <EFArrowRightForAni />
                                </span>
                            </Link>
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
